import createReactClass from 'create-react-class';
import type React from 'react';

import { Switch, View } from '@zinc/ui';
import { type ReactNode, useId } from 'react';
import PublishMixin from '../../mixins/publish-mixin';

export interface IProps {
  id?: string;
  label?: string | ReactNode;
  checked?: boolean;
  onChange: (e: any, value: boolean) => void;
  readonly?: boolean;
  dataTestId?: string;
}

function BzToggle({ label, id, checked, onChange, readonly }: IProps) {
  const fallback = useId();
  const switchId = id ?? fallback;
  return (
    <View direction="row" gap={2}>
      <Switch
        disabled={readonly}
        name={switchId}
        checked={checked}
        onChange={(e) => onChange(e.event, e.checked)}
      />
      {label}
    </View>
  );
}

export default BzToggle;
